import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=4974b608&scoped=true&"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeSelect.vue?vue&type=style&index=0&id=4974b608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974b608",
  null
  
)

export default component.exports